// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-delivery-template .demo-image__preview[data-v-1467e914] {\n  display: inline-block;\n}\n.order-delivery-template .demo-image__preview .el-image[data-v-1467e914] {\n  width: 50px;\n  height: 50px;\n}\n.order-delivery-template .detailSection[data-v-1467e914] {\n  padding: 25px 15px !important;\n}", ""]);
// Exports
module.exports = exports;
